<template>
    <div class="common-list-cell">
        <ul class="order-title">
            <li style="flex: 1">
                <span>单号：</span>
                <span class="blue-text" @click="viewOrder(orderData)" v-if="['stockOut', 'stockIn', 'createIn'].indexOf(type) > -1">{{orderData.customOrderNo||orderData.stockOutNo}}</span>
                <span class="blue-text" @click="viewOrder(orderData)" v-else-if="type==='mengniu'">{{orderData.invoiceNo}}</span>
                <span v-else class="blue-text" @click="viewOrder(orderData)">{{orderData.orderNo}}</span>
                <span class="red-text">({{orderStatus(orderData.status)}})</span>
            </li>
            <li style="flex: 1">
                <p>发货组织：
                    <span style="color: #333;">{{orderData.outOrgName}}</span>
                    <span style="color: #333;">({{orderData.outWarehouseName||orderData.outOrgCode}})</span>
                </p>
            </li>
            <li style="flex: 1">
                <p>收货组织：
                    <span style="color: #333;">{{orderData.inOrgName}}</span>
                    <span style="color: #333;">({{orderData.inWarehouseName||orderData.inOrgCode}})</span>
                </p>
            </li>
            <p></p>
        </ul>
        <div class="order-item" v-if="['stockOut', 'stockIn', 'createIn'].indexOf(type) > -1">
            <ul class="order-content-info" v-for="(details,index) of orderData.skuBatchList" :key="index">
                <li style="flex: 3">
                    <p>{{details.name}}</p>
                    <p class="gray-text" style="font-size: 12px">编号: {{details.code}}</p>
                </li>
                <li style="flex: 7">
                    <ul class="order-batch-info">
                        <li v-for="(batchInfo,index) of details.list" :key="index">
                            <p style="flex: 2">{{batchInfo.batchNo}}</p>
                            <p style="flex: 2">{{batchInfo.unitName}}</p>
                            <p style="flex: 2">{{batchInfo.quality}}</p>
                            <p style="flex: 1" v-if="type=='stockOut'">{{batchInfo.outQuality}}</p>
                            <p style="flex: 1" v-else>{{batchInfo.inQuality}}</p>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
        <div class="order-otem" v-else-if="type === 'mengniu'">
            <ul class="order-content-info" v-for="(details,index) of orderData.invoiceGoodsList" :key="index">
                <li style="flex: 2">
                    <p>{{details.skuName}}</p>
                    <p class="gray-text" style="font-size: 12px">编号: {{details.skuId}}</p>
                </li>
                <li style="flex: 8">
                    <ul class="order-batch-info">
                        <li>
                            <p style="flex: 3; word-break: keep-all; line-height: 1.5;white-space: pre-wrap;">{{details.batchNo?details.batchNo.replace(/,/g, ', '):''}}</p>
                            <p style="flex: 2">{{details.unit}}</p>
                            <p style="flex: 2">{{details.quantity}}</p>
                            <p style="flex: 1">/</p>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
        <div class="order-item" v-else>
            <ul class="order-content-info" v-for="(details,index) of orderData.bizOrderDetails" :key="index">
                <li style="flex: 3">
                    <p>{{details.skuName}}</p>
                    <p class="gray-text" style="font-size: 12px">编号: {{details.skuCode}}</p>
                </li>
                <li style="flex: 7">
                    <ul class="order-batch-info">
                        <li v-for="(batchInfo,index) of details.batchInfos" :key="index">
                            <p style="flex: 2">{{batchInfo.batchNo}}</p>
                            <p style="flex: 2">{{details.unitName}}</p>
                            <p style="flex: 2">{{batchInfo.quality}}</p>
                            <p style="flex: 1">/</p>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
        <div class="order-item-bottom">
            <p style="color: #999;">
                <span>下单时间:</span>
                <span>{{orderData.createDate}}</span>
                <!-- 新增物流单号 (orderData.logisticsNo !== null)-->
                <span style="margin-left:17.5vw" v-if="orderData.logisticsNo && (orderData.status === 4 || orderData.status===3 || orderData.status===2) && (type=='stockOut')">物流单号:{{orderData.logisticsNo}}</span>
                <span style="margin-left:17.5vw" v-if="orderData.logisticsNo && (orderData.status === 3 || orderData.status === 4) && (type=='goods')">物流单号:{{orderData.logisticsNo}}</span>
                <span style="margin: 0 0 0 20px;" v-if="type==='mengniu'">创建人:</span>
                <span v-if="type==='mengniu'">{{orderData.createAccount}}</span>
            </p>
                <!--建单出库不展示操作按钮-->
                <p v-if="type=='stockOut'&&orderData.type!=8">
                    <el-button type="warning" plain @click="finishOrder(orderData)" v-if="orderData.type===5&&orderData.status===1&&hasPermission('menu:order:out:finish')">
                        结束订单
                    </el-button>
                    <!-- 新增上传物流单号 -->
                    <el-button type="warning" plain @click="uploadLogistics(orderData)" v-if="orderData.status===4 || orderData.status===3 || orderData.status===2">上传物流单号</el-button>
                    <el-button type="warning" plain @click="sureOrder(orderData)" v-if="(orderData.status===0||orderData.status===1)&&hasPermission('menu:order:out:confirm')">
                        {{$STR('menu:order:out:confirm', '确认出库')}}
                    </el-button>
                    <el-button type="warning" plain @click="cancelOrder(orderData)" v-if="(orderData.status===0)&&hasPermission('menu:order:out:cancel')">
                        {{$STR('menu:order:out:cancel', '取消订单')}}
                    </el-button>
                    <!-- 打印 -->
                    <print-order :printData="orderData"  :tennatId="tennatId" :tenantList="tenantList" v-if="[0,1,2,3,4].indexOf(orderData.status) > -1 &&hasPermission('menu:order:out:print')"></print-order>
                </p>
                <p v-if="type=='stockOut'&&orderData.type==8">
                    <print-order :printData="orderData" v-if="[2,3,4].indexOf(orderData.status) > -1 && hasPermission('menu:order:out:print')"></print-order>
                </p>
                <p v-if="type=='stockIn'">
                    <el-button type="warning" plain @click="finishOrder(orderData)" v-if="orderData.type===5&&orderData.status===3&&hasPermission('menu:order:in:finish')">
                        结束订单
                    </el-button>
                    <el-button type="warning" plain @click="sureOrder(orderData)" v-if="(orderData.status===2||orderData.status===3)&&hasPermission('menu:order:in:confirm')">
                        {{$STR('menu:order:in:confirm', '确认入库')}}
                    </el-button>
                    <el-button type="warning" plain @click="cancelOrder(orderData)" v-if="(orderData.status===2)&&hasPermission('menu:order:in:reject')">
                        {{$STR('menu:order:in:reject', '拒收订单')}}
                    </el-button>
                </p>
                <p v-if="type=='createIn'">
                    <el-button type="warning" plain @click="cancelOrder(orderData)" v-if="(orderData.status===2)&&hasPermission('menu:order:createIn:cancel')">
                        {{$STR('menu:order:out:cancel', '取消订单')}}
                    </el-button>
                </p>
                <p v-if="type=='goods' || type=='allot'">
                    <el-button type="warning" plain v-if="hasPermission('menu:order:preorder:confirm')&&orderData.button.orderConfirm" @click="operateHandle(orderData, 2,'确认')">
                        {{$STR('menu:order:preorder:confirm', '确认订单')}}
                    </el-button>
                    <el-button type="warning" plain v-if="hasPermission('menu:order:preorder:reject')&&orderData.button.turnDown" @click="operateHandle(orderData, -2,'驳回')">
                        {{$STR('menu:order:preorder:reject', '驳回订单')}}
                    </el-button>
                    <el-button type="warning" plain v-if="hasPermission('menu:order:preorder:delete')&&orderData.button.deleteOrder" @click="operateHandle(orderData, -3)">
                        {{$STR('menu:order:preorder:delete', '删除订单')}}
                    </el-button>
                    <el-button type="warning" plain v-if="hasPermission('menu:order:out:cancel')&&orderData.button.cancelOrder" @click="operateHandle(orderData, -1,'取消')">
                        {{$STR('menu:order:out:cancel', '取消订单')}}
                    </el-button>
                    <el-button type="warning" plain v-if="hasPermission('menu:order:preorder:confirm:cancel')&&orderData.button.cancelConfirm" @click="operateHandle(orderData, 0,'取消确认')">
                        {{$STR('menu:order:preorder:confirm:cancel', '取消确认')}}
                    </el-button>
                    <el-button type="warning" plain v-if="hasPermission('menu:order:preorder:neednotdeliver') && orderData.button.needNotDeliver" @click="operateHandle(orderData, 5,'无需发货')">
                        {{$STR('', '无需发货')}}
                    </el-button>
                    <el-button type="warning" plain v-if="hasPermission('menu:order:preorder:out:add')&&orderData.button.createStockOut&&orderData.outOrderFlag" @click="operateHandle(orderData, 999)">
                        {{$STR('menu:order:preorder:out:add', '生成出库单')}}
                    </el-button>
                    <el-button type="warning" plain v-if="hasPermission('menu:order:preorder:checkoutinrecord') && orderData.button.checkOutIn" @click="operateHandle(orderData, 998)">
                        {{$STR('', '查看出库单记录')}}
                    </el-button>
                    <el-button type="warning" plain v-if="hasPermission('menu:order:preorder:redeliver') && orderData.button.restoreDeliver" @click="operateHandle(orderData, 222)">
                        {{$STR('', '还原发货')}}
                    </el-button>
                </p>
                <p v-if="type=='mengniu'">
                    <el-button type="warning" plain @click="updateOrder(orderData)" v-if="parseInt(orderData.status)===1&&hasPermission('order:mengniu:update')">
                        更改状态
                    </el-button>
                    <el-button type="warning" plain v-if="parseInt(orderData.status)===0&&hasPermission('order:mengniu:delete')" @click="deleteOrder(orderData)">
                        {{$STR('menu:order:preorder:delete', '删除订单')}}
                    </el-button>
                </p>
        </div>
        <!-- <upLogisticNum ref="logistic" :stockoutnum="stockOutNo"></upLogisticNum> -->
        <el-dialog
            title="上传物流单号"
            :visible.sync="dialogVisible"
            @close="cancelDialog"
            class="dialog-large"
            width="35%"
        >
        <div style="display: flex;align-items: center;padding:45px 0">
            <span>物流单号：</span>
            <el-input v-model="logisticsNo"></el-input>
            <el-button type="primary" plain style="margin-left:10px" @click="confirmUpload">确认上传</el-button>
        </div>
        </el-dialog>
    </div>
</template>
<script>
// import {mapState, mapGetters, mapActions} from 'vuex';
import PrintOrder from './stockOut/PrintOrder';
// import upLogisticNum from './stockOut/components/uploadLogistics';
export default {
    components: {
        PrintOrder,
        // upLogisticNum
    },
    data () {
        return {
            dialogVisible: false, //上传物流单号弹框
            logisticsNo: '', // 物流单号
            tennatId: baseStore.getTenantId(),
            tenantList: tenantList,
            stockOutNo: ''
        };
    },
    props: ['orderData', 'type'],
    filters: {
    },
    created() {
    },
    methods: {
        //关闭上传物流单号对话框
        cancelDialog() {
            this.dialogVisible = false;
            this.logisticsNo = '';
        },
        confirmUpload() {
            //发起上传物流单号的接口请求
            this.$http
                .patch(WebApi.warehouse.upLoadLogisticNo, { stockOutNo: this.stockOutNo, logisticsNo: this.logisticsNo })
                .then(res => {
                    console.log(res);
                    if (this.logisticsNo === '') {
                        return this.$message.error('物流单号不能为空');
                    }
                    if (res.data.success) {
                        this.$message.success('上传成功');
                        this.dialogVisible = false;
                        this.logisticsNo = '';
                        this.$emit('refreshClick');
                    }
                });
        },
        /**************************************** */
        uploadLogistics(data) {
            // this.$refs.logistic.dialogVisible = true;
            this.dialogVisible = true;
            //获取物流单号
            this.stockOutNo = data.stockOutNo;
        },
        // 打印订单
        printOrder (data) {
            this.$emit('printOrder', data.bizOrderDetails);
        },
        viewOrder(data) {
            console.log(data, 'data___');
            let url = '';
            switch (this.type) {
            case 'stockOut':
                url = '/cloud/order/stockOut/detail';
                //传递物流单号
                // this.$bus.$emit('getLogisticsNo', data.logisticsNo);
                break;
            case 'stockIn':
            case 'createIn':
                url = '/cloud/order/stockIn/detail';
                break;
            case 'allot':
                url = '/cloud/order/allot/detail';
                break;
            case 'goods':
                url = '/cloud/order/goods/detail';
                this.$bus.$emit('getReceiveAddr', data);
                break;
            case 'return':
                url = '/cloud/order/return/detail';
                break;
            case 'mengniu':
                url = '/cloud/order/mengniu/detail';
                break;
            }
            this.$store.dispatch('addTabs', {
                route: url + '?id=' + data.id,
                name: this.$STR('ORDER.orderListCell.viewOrder', '查看订单')
            });
            this.$store.dispatch('saveCodeDetails', data);
        },
        // 删除订单
        deleteOrder (orderData) {
            this.$parent.deleteOrder(orderData);
        },
        // 修改订单
        updateOrder (orderData) {
            this.$parent.updateOrder(orderData);
        },
        finishOrder(orderData) {
            this.$emit('finishOrder', orderData);
        },
        sureOrder(orderData) {
            this.$emit('sureOrder', orderData);
        },
        cancelOrder(orderData) {
            console.log(orderData);
            this.$emit('cancelOrder', orderData);
        },
        operateHandle(data, status, text) {
            this.$emit('operateHandle', data, status, text);
        },
        orderStatus: function (data) {
            // 出库订单
            if (this.type === 'stockOut') {
                if (data === 0) {
                    return this.$STR('ORDER.order.orderStatus.waitOut', '待发货');
                } else if (data === 1) {
                    return this.$STR('ORDER.order.orderStatus.outing', '发货中');
                } else if (data === 2 || data === 3 || data === 4) {
                    return this.$STR('ORDER.order.orderStatus.outed', '已发货');
                } else if (data === 5) {
                    return this.$STR('COMMON.common.msg.cancel', '已取消');
                } else if (data === 6) {
                    return this.$STR('ORDER.order.orderStatus.rejected', '已拒收');
                }
            }
            // 建单入库、入库订单
            if (this.type === 'stockIn' || this.type === 'createIn' ) {
                if (data === 2) {
                    return this.$STR('ORDER.order.orderStatus.waitOut', '待收货');
                } else if (data === 3) {
                    return this.$STR('ORDER.order.orderStatus.outing', '收货中');
                } else if (data === 4) {
                    return this.$STR('ORDER.order.orderStatus.received', '已收货');
                } else if (data === 6) {
                    return this.$STR('ORDER.order.orderStatus.rejected', '已拒收');
                } else if (data === 5) {
                    return this.$STR('COMMON.common.msg.cancel', '已取消');
                }
            }
            // 订货订单
            if (this.type === 'goods') {
                if (data === 0) {
                    return this.$STR('ORDER.order.orderStatus.waitConfirm', '待确认');
                } else if (data === 2) {
                    return this.$STR('ORDER.order.orderStatus.waitOut', '待发货');
                } else if (data === 3) {
                    return this.$STR('ORDER.order.orderStatus.waitReceive', '待收货');
                } else if (data === 4) {
                    return this.$STR('ORDER.order.orderStatus.finished', '已完成');
                } else if (data === -2) {
                    return this.$STR('ORDER.order.orderStatus.reject', '已驳回');
                } else if (data === -1) {
                    return this.$STR('COMMON.common.msg.cancel', '已取消');
                } else if (data === 5) {
                    return this.$STR('COMMON.common.msg.cancel', '已取消');
                }
            }
            // 调拨订单
            if (this.type === 'allot') {
                if (data === -2) {
                    return this.$STR('ORDER.order.orderStatus.reject', '已驳回');
                } else if (data === -1) {
                    return this.$STR('COMMON.common.msg.cancel', '已取消');
                } else if (data === 0) {
                    return this.$STR('ORDER.order.orderStatus.waitConfirm', '待确认');
                } else if (data === 1) {
                    return this.$STR('ORDER.order.orderStatus.confirmed', '已确认');
                } else if (data === 2) {
                    return this.$STR('ORDER.order.orderStatus.waitOut', '待发货');
                } else if (data === 3) {
                    return this.$STR('ORDER.order.orderStatus.waitReceive', '待收货');
                } else if (data === 4) {
                    return this.$STR('ORDER.order.orderStatus.finished', '已完成');
                }
            }
            // 退货订单
            if (this.type === 'return') {
                if (data === 2) {
                    return this.$STR('ORDER.orderList.data.statusList.waitOut', '待发货');
                } else if (data === 3) {
                    return this.$STR('ORDER.orderList.data.statusList.waitReceive', '待收货');
                } else if (data === 4) {
                    return this.$STR('ORDER.orderList.data.statusList.finished', '已完成');
                } else if (data === -1) {
                    return this.$STR('COMMON.common.msg.cancel', '已取消');
                }
            }
            if (this.type === 'mengniu') {
                if (parseInt(data) === 0) {
                    return this.$STR('ORDER.orderList.data.statusList.waitOut', '待发货');
                } else if (parseInt(data) === 1) {
                    return this.$STR('ORDER.order.orderStatus.outed', '已发货');
                }
            }
        }
    }
};
</script>
<style scoped>
    .common-list-cell{
        color: #333333;
    }
    .order-item .order-content-info:last-child{
        border-top: 0px;
    }
    .order-title{
        display: flex;
        background-color: rgb(245,247,250);
        color: #999b9c;
        padding: 8px 20px;
        border: 1px solid #eee;
    }
    .order-content-info{
        display: flex;
        padding: 10px 20px;
        align-items: center;
        border: 1PX #eee solid;
        border-top: 0px;
    }
    .order-content-info>li>p{
        padding: 5px;
    }
    .order-batch-info>li{
        display: flex;
    }
    .order-batch-info>li>p{
        padding: 5px;
    }
    .order-item-bottom{
        display: flex;
        padding: 10px 20px;
        align-items: center;
        justify-content: space-between;
        border: 1px solid #eee;
        border-top: none;
    }
</style>



// WEBPACK FOOTER //
// src/views/cloud/order/commonListCell.vue